export const PAST_CAR_TERMINATED_PROMPT = 'This is an old car model that is no longer for sale by the local distributor'; // @suppress longLineCheck
